"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../types");
const order_1 = require("../order");
let ratePlanId;
let invoiceId;
let invoiceBalance;
const testFirmAdminSubscription = {
    subscriptionNumber: 'string',
    subscriptionId: 'string',
    renewalDate: 'string',
    subscriptionStartDate: 'string',
    subscriptionAccountId: 'string',
    subscriptionInvoiceOwnerId: 'string',
    membershipType: types_1.User.MembershipType.AICPA,
    customerType: 'string',
    autoRenew: false,
    userName: 'string',
    oktaId: 'string',
    aicpaId: 'string',
    email: 'string',
    productName: 'string',
    sku: 'string',
    benefitSkus: ['string'],
    productPrice: 1,
    memberDiscount: 0,
    ratePlan: 'string',
    ratePlanId,
    invoiceId,
    invoiceBalance,
};
let totalAddonCost;
let isSubscriptionsFetched;
let initialMembershipType;
let initialFlpSubscriptionType;
let initialFlpSubscriptionDuration;
exports.testFirmRosterMember = {
    userId: 'string',
    organizationId: 'string',
    rootOrganizationId: 'string',
    firstName: 'string',
    firstNameLower: 'string',
    lastName: 'string',
    lastNameLower: 'string',
    oktaId: 'string',
    email: 'string',
    isPaidByFirm: true,
    isAddToFirmBillingDisabled: true,
    isAddToFlpFirmBillingDisabled: true,
    isAdmin: false,
    isHonorary: false,
    isTLW: false,
    isStudent: false,
    position: types_1.MembershipTypes.RolesNames.Partner,
    membershipType: 'string',
    membershipTier: 'string',
    membershipStatus: types_1.User.MembershipStatus.ACTIVE,
    branchCountry: 'string',
    branchState: 'string',
    branchCity: 'string',
    officeLocation: 'string',
    createDateTime: 'string',
    applicationNumber: 'string',
    address: order_1.testAddress,
    aicpaId: 'string',
    relationWithFirm: 'string',
    organizationJunctionId: 'string',
    firmBillingJunctionId: 'string',
    flpFirmBillingJunctionId: 'string',
    studentBillingJunctionId: 'string',
    individualId: 'string',
    emailId: 'string',
    expiryDate: 'string',
    subscriptionStatus: types_1.User.MembershipSubscriptionStatus.INVOICED_PAID,
    subscriptions: [testFirmAdminSubscription],
    totalAddonCost,
    isSubscriptionsFetched,
    initialMembershipType,
    initialFlpSubscriptionType,
    initialFlpSubscriptionDuration,
};
//# sourceMappingURL=firm-billing-types.js.map